export default "__VITE_ASSET__47eb6a90__"